import { helper } from '@ember/component/helper';

const matchQueryParams = /\?/;
const matchDelimiter   = /[?&]$/;

export default helper(function addQueryParamsHelper([ url, ...params ]) {
  let delimiter = matchQueryParams.test(url) ? '&' : '?';
  const addParam = (key, value) => {
    url += (matchDelimiter.test(url) ? '' : delimiter) + key
      + (value !== undefined && value !== null ? '=' + value : '');
    delimiter = '&';
  };
  params.forEach(param => {
    if (Array.isArray(param)) {
      param.forEach(param => {
        if (Array.isArray(param)) {
          addParam(...param);
        }
      });
    }
  });
  return url;
});
